import React from "react";
// import "./style.css";

export default function RadioSelect(props) {
  console.log(props.checked)
  return (
    <div className="to-center d-flex align-items-center ">
      <input type="radio" {...props} defaultChecked = {props?.checked} className="mx-2 pb-2" />
      {props.label && (
        <label className="">{props.label}</label>
      )}
    </div>
  );
}
